import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

const i18nRoot = "settings.workflows.form";

export const useFetchLesson = ({ lessonId }: { lessonId: string | null }) => {
  const { error } = useToast();

  return useQuery(
    ["workflows", "list", "lessons", lessonId],
    () =>
      reactQueryGet(
        internalApi.settings.courses.lessons.show({ id: lessonId as string }),
      ),
    {
      onError: () => error(t([i18nRoot, "errors", "lessons", "fetch_failed"])),
      enabled: !!lessonId,
    },
  );
};
